import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-package-group-country',
  templateUrl: './package-group-country.component.html',
  styleUrls: ['./package-group-country.component.css']
})
export class PackageGroupCountryComponent implements OnInit {

 
  


  Submitted: boolean = false;
  PackageList: any;
  ParentList: any;
  GroupCountryList:any;

  constructor(private subcriptionService: SubscriptionService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


     GroupModel = {
      GroupCountryName:"",
      GroupCountryID: 0,
      BillingTypeID: 0,   

  };

  ClearGroupCountry() {
    this.Submitted = false;
  
    this.GroupModel.GroupCountryName = "";
    this.GroupModel.GroupCountryID = 0;
    this.GroupModel.BillingTypeID = 0;

  };


  



  validation() {
    return this.GroupModel.BillingTypeID == 0;
  }
  SaveGroupCountry(valid) {

    this.Submitted = true;
    if (valid && !this.validation()) {
      this.spinnerService.show();
      this.subcriptionService.SaveGroupCountry(JSON.stringify(this.GroupModel)).subscribe((data: any) => {
        this.GetAllGroupCountry();
        this.spinnerService.hide();

        this.ClearGroupCountry();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  GetAllGroupCountry() {
    this.subcriptionService.GetAllGroupCountry(JSON.stringify(this.GroupModel)).subscribe((data: any) => {
      this.GroupCountryList = data.GroupCountryList;
    });

  }
  CountryList:any;
  GetCountry() {
    this.subcriptionService.GetCountry(JSON.stringify(this.GroupModel)).subscribe((data: any) => {
      this.CountryList = data.CountryList;
    });

  }
  SelectCountryList:any;
  GetSelectCountry() {
    this.subcriptionService.GetSelectCountry(JSON.stringify(this.GroupModel)).subscribe((data: any) => {
      this.SelectCountryList = data.SelectCountryList;
    });

  }
  RemoveCountry() {

    this.Submitted = true;
    if (true) {
      this.spinnerService.show();
      this.subcriptionService.RemoveCountry(JSON.stringify(this.GroupModel),JSON.stringify(this.SelectCountryList)).subscribe((data: any) => {
        this.GetCountry();
        this.GetSelectCountry();
        this.spinnerService.hide();
        
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }
  ADDCountry() {

    this.Submitted = true;
    if (true) {
      this.spinnerService.show();
      this.subcriptionService.ADDCountry(JSON.stringify(this.GroupModel),JSON.stringify(this.CountryList)).subscribe((data: any) => {
        this.GetSelectCountry();
        this.GetCountry();
        this.spinnerService.hide();        
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }
  EditGroupCountry(obj) {
   
    this.GroupModel.GroupCountryID = obj.GroupCountryID;
    // this.GroupModel.GroupCountryName = obj.GroupCountryName;
    // this.GroupModel.BillingTypeID = obj.BillingTypeID;
  
this.GetCountry();
this.GetSelectCountry();
  };

  ngOnInit() {

    this.GetBillingType();
   
    this.GetAllGroupCountry();
  }


  // GetAllPackage() {

  //   this.LookupService.GetLookupsList('PackageForMatrix', '').subscribe((data: any) => {
  //     this.PackageList = data.LookupItems;
  //   });
  // }
  BillingTypeList:any;
  GetBillingType() {

    this.LookupService.GetLookupsList('BillingType', '').subscribe((data: any) => {
      this.BillingTypeList = data.LookupItems;
    });
  }


}

